import { useState } from "react";

export default function useTheme() {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  const saveTheme = () => {
    const themeString = theme === "light" ? "dark" : "light";
    localStorage.setItem("theme", themeString);
    setTheme(themeString);
  };

  const changeTheme = () => {
    const n = "dx-swatch-dark";
    const allClasses =
      document.body.className.indexOf(n) >= 0 ? "light" : "dark";
    allClasses === "dark"
      ? document.body.classList.add(n)
      : document.body.classList.remove(n);
    saveTheme();
  };
  return {
    setTheme: saveTheme,
    themeColor: theme,
    changeTheme,
  };
}
